import Enum from 'enum';

/**
 * The type of a message,
 * either a common message or a post.
 */
export default new Enum(['MESSAGE', 'POST'], { ignoreCase: true });
